import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../firebase";
import toast from "react-hot-toast";
import { getUserLabels } from "../services/labelService";
import MetricCardForm from "../components/MetricCardForm";

// Thin wrapper around the shared MetricCardForm that creates a new metricCard.
// Default export name kept as `CaseModal` for backward-compatible imports.
export default function CaseModal({ onClose, onSaved, cases = [], nextOrder = 0 }) {
  const { globalUser } = useAuth();
  const navigate = useNavigate();
  const [labels, setLabels] = useState([]);

  const close = () => (onClose ? onClose() : navigate("/portal/Dashboard"));
  const saved = () => (onSaved ? onSaved() : navigate("/portal/Dashboard"));

  useEffect(() => {
    if (!globalUser) return;
    getUserLabels(globalUser.uid)
      .then(setLabels)
      .catch((err) => console.error("Error fetching labels:", err));
  }, [globalUser]);

  const handleSubmit = async (formData) => {
    if (!globalUser) {
      toast.error("User not authenticated");
      return;
    }
    try {
      await addDoc(collection(db, "metricCard"), {
        owner: globalUser.uid,
        order: nextOrder,
        ...formData,
      });
      toast.success("Card added successfully!");
      saved();
    } catch (error) {
      console.error(error);
      toast.error("An error occurred!");
      close();
    }
  };

  return (
    <MetricCardForm
      mode="add"
      labels={labels}
      cases={cases}
      uid={globalUser?.uid}
      onClose={close}
      onSubmit={handleSubmit}
    />
  );
}
